var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "iframe-modal" },
    [
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.isComplete
              ? "该服务关联了多条核名记录"
              : "该服务关联了多条核名记录，需要全部确认完成",
            visible: _vm.nameVerificationReportVisible,
            footer: false,
            width: "680px",
            centered: ""
          },
          on: {
            cancel: function($event) {
              _vm.nameVerificationReportVisible = false
            }
          }
        },
        [
          _c("a-table", {
            attrs: {
              rowKey: "id",
              pagination: false,
              columns: _vm.columns,
              "data-source": _vm.workRelWorkOrderList
            },
            scopedSlots: _vm._u([
              {
                key: "recordStatus",
                fn: function(text) {
                  return _c("span", {}, [
                    _vm._v(_vm._s(_vm.recordStatusMap[text]))
                  ])
                }
              },
              {
                key: "operate",
                fn: function(text, record) {
                  return _c(
                    "span",
                    { staticClass: "operate-btn" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "link" },
                          on: {
                            click: function($event) {
                              return _vm.goReportPage(record)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.isComplete ? "查看报告" : "确认核名报告")
                          )
                        ]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dd4cbba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd4cbba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NameVerificationReportPop.vue
// module id = null
// module chunks = 